import React from 'react';
import { Card, Typography, Progress, Alert } from 'antd';
const { Text } = Typography;

export default function ExportProgress({ progress, title = 'Export FTP' }) {
  if (!progress) return null;
  const stages = {
    queued: 'En attente de démarrage…',
    reconnecting: 'Connexion au suivi interrompue — nouvelle tentative…',
    starting: 'Démarrage de l’export…',
    generating: 'Lecture des données et génération des fichiers DBF…',
    connecting: 'Connexion au serveur FTP…',
    connected: 'Connexion FTP établie',
    preparing: 'Préparation du dossier de destination…',
    uploading: 'Transfert du fichier vers le serveur FTP…',
    uploaded: 'Fichier transféré — préparation de la suite…',
    retrying: `Nouvelle tentative de transfert (${progress?.attempt || 1}/${progress?.maxRetries || 5})…`,
    file_failed: 'Échec du transfert du fichier',
    disconnecting: 'Fermeture de la connexion FTP…',
    completed: 'Export terminé',
    failed: 'Export terminé avec une erreur'
  };

  return (
    <Card size="small" style={{ marginBottom: 24 }}>
      <div role="status" aria-live="polite">
        <Text strong>{progress.table || title}</Text>
        {progress.file && <Text style={{ marginLeft: 12 }}>{progress.file}</Text>}
        <div style={{ marginTop: 8 }}>{stages[progress.stage] || progress.stage}</div>
      </div>
      <Progress
        percent={progress.percent || 0}
        status={progress.stage === 'failed' ? 'exception' : progress.stage === 'completed' ? 'success' : 'active'}
        aria-label="Progression globale de l’export"
      />
      {progress.totalFiles > 0 && <Text type="secondary">{progress.uploadedCount} / {progress.totalFiles} fichiers transférés</Text>}
      {progress.stage === 'uploading' && progress.totalBytes > 0 && (
        <div><Text type="secondary">
          Fichier : {Math.min(100, Math.floor(100 * progress.bytes / progress.totalBytes))} %
          {' — '}{(progress.bytes / 1048576).toFixed(2)} / {(progress.totalBytes / 1048576).toFixed(2)} Mo
        </Text></div>
      )}
      {progress.stage === 'failed' && <Alert type="error" showIcon message={progress.message} style={{ marginTop: 12 }} />}
      {progress.ftpUpload?.failedFiles?.map(({ file, error }) => (
        <div key={file}><Text type="danger">{file.split('/').pop()} : {error}</Text></div>
      ))}
    </Card>
  );
}
